// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"c6019509","276":"c6019509","679":"c6019509"}[chunkId] + ".chunk.css";
};